<template>
  <div class="dz-message upload-media" :class="{ 'dropzone-container': true, 'uploaded-files': files.length }"
    @dragover="dragover" @dragleave="dragleave" @drop="drop">
    <span class="media-file-input">
      <input type="file" multiple name="file" id="fileInput" class="hidden-input" @change="onChange" ref="file"
        accept=".pdf,.jpg,.jpeg,.png" />
    </span>
    <label for="fileInput" class="file-label">
      <i class="fa fa-plus-circle iconSize" v-if="files.length === 0"></i>
      <div v-if="isDragging">Release to drop files here.</div>
      <div v-else>
        <div class="preview-container" v-if="files.length">
          <div v-for="file in files" :key="file.name" class="preview-card">
            <div>
              <img class="preview-img" :src="generateURL(file)" />
              <p style="padding: 0;">
                {{ file.name }}
              </p>
            </div>
            <div>
              <button class="ml-2" type="button" @click="remove(files.indexOf(file))" title="Remove file">
                <b>×</b>
              </button>
            </div>
          </div>
        </div>
      </div>
    </label>
  </div>
</template>


<script>
export default {
  data() {
    return {
      isDragging: false,
      files: [],
    };
  },
  methods: {
    onChange() {
      this.files = [...this.$refs.file.files];
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    remove(i) {
      this.files.splice(i, 1);
    },
    generateURL(file) {
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },

    uploadFiles() {
      const files = this.files;
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("selectedFiles", file);
      });

      return axios.post("/galleries", formData, {
        accept: "multipart/form-data",
      });
    },
  },
};
</script>


<style scoped>
.dropzone-container {
  padding: 3rem;
  background: white;
  text-align: center;
  border: 2px dashed black !important;
  margin-bottom: 10px;
}

.uploaded-files {
  padding: 0;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: flex;
  margin-top: 0;
}

.preview-card {
  border: none;
}

.iconSize {
  font-size: 2em !important;
}

.preview-img {
  width: 100px;
  height: 100px;
}
</style>